module.exports = __webpack_public_path__ + "img/logo.4adda8c6.png";